/* eslint-disable import/prefer-default-export */
export const GET_ANALYTICS = 'GET_ANALYTICS';
